module.exports = __webpack_public_path__ + "img/half_circle_layout.5b2fc9c1.svg";